export default "/_next/static/images/success-membership-8b3d3c26d8b710aba86188965e5379f0.png";